import { useEffect, useState } from "react";
import {currencyServices} from '../../services/currencyservices';

const Currency = () =>{
    const [initialcurr,setCurr] = useState([]);

    useEffect(()=>{
        getCurr();   
    },[])

    const getCurr = () =>{
        currencyServices.getcurrency().then((response)=>{
            if(response.status == 200){
                setCurr(response.data.data);
            }else{
                setCurr([]);  
            }    
        }).catch((error)=>{
            setCurr([]);       
        }) 
        
    }

    const displayCurr = () =>{
        let array = [];
        initialcurr.forEach((value)=>{
            array.push(<option value={value.id}>{value.fullname}</option>);    
        })
        return array;
    }

    const updatecurrency = (e) =>{
         
    }
   
    return (
        <>
             <div className="card">
                <div className='card-body'>
                    <label><b> Currencies</b></label> 
                    <br/>
                    <br/>
                    <div className='col-md-3'>
                        <select className='form-control' onChange={updatecurrency}>
                            {displayCurr()}
                        </select>      
                    </div> 
                </div> 
            </div>
        </>
    )
   
}

export default Currency;    